import React, { FC } from "react";
import { Modal, Text } from "venice-ui";
import { t } from "../../helpers/userHelper";
import { dictionary } from "../../untils/dictionary";
import { apiCall } from "../../untils/apiCall";
import { useStoreActions, useStoreState } from "../../store";

interface IDeleteProjectModalProps {
  handleCancel: () => any;
  id: string;
  name: string;
  isOpen: boolean;
  handleCancelWithAction?: () => any;
}

export const DeleteProjectModal: FC<IDeleteProjectModalProps> = ({
  handleCancel,
  name,
  id,
  isOpen,
  handleCancelWithAction,
}) => {
  const { id: orgID } = useStoreState((state) => state.organization);
  const { removeProjectFromUser } = useStoreActions((actions) => actions.user);
  const { removeProjectFromOrganization } = useStoreActions(
    (actions) => actions.organization,
  );
  const { deleteProject: deleteProjectsFromStore } = useStoreActions(
    (actions) => actions.projects,
  );

  const deleteProject = async (projectID: string) => {
    await apiCall(
      "projects/removeProject",
      {
        orgID,
        projectID,
      },
      (response: any) => {
        //remove proejct from userDetails => contracts => project
        removeProjectFromUser({ projectID });

        //remove project from organization => contracts => projects
        //remove project form access in organization => members => access
        removeProjectFromOrganization({ projectID });

        //remove project from projects => projects
        deleteProjectsFromStore({ projectID });
        if (handleCancelWithAction) {
          handleCancelWithAction();
        } else {
          handleCancel();
        }
      },
    );
  };

  return (
    <Modal
      title={t(dictionary.confirmDelete)}
      labelClose={t(dictionary.cancel)}
      handleClose={handleCancel}
      handleConfirm={() => deleteProject(id)}
      labelConfirm={t(dictionary.delete)}
      isOpen={isOpen}
      exitOnEsc={true}
    >
      <Text>{name}</Text>
      <Text>{t(dictionary.doYouWantDeleteProject)}</Text>
    </Modal>
  );
};
